<template>
  <div class="search-bar" :style="wrapperStyles">
    <DimensionsSelector :is-banner="isBanner" @search="search" />
    <Autocomplete :is-banner="isBanner" @search="search" />
    <div v-show="!hasSearchText" class="search-icon-container" @click="search">
      <Icon color="#9a9a9a" icon="search-big" :width="22.5" :height="22.5" />
    </div>
    <div v-show="hasSearchText" class="search-icon-container close" @click="clear">
      <Icon icon="bootstrap-x" :width="24" :height="24" />
    </div>
  </div>
</template>

<script>
import DimensionsSelector from './DimensionsSelector';
import Autocomplete from './Autocomplete';
import { mapState, mapGetters } from 'vuex';
import Icon from 'UI/Icon';
export default {
  name: 'SearchBar',
  components: {
    Autocomplete,
    DimensionsSelector,
    Icon
  },
  props: {
    isBanner: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    hasSearchText() {
      return this.actualSearch && this.actualSearch.length > 0;
    },
    ...mapState('searchBar', ['actualSearch', 'hasSuggestionSelected', 'elementSelected']),
    ...mapGetters('searchBar', ['isAnyOpen', 'getShowingDropdown']),
    ...mapGetters('dimensions', ['getActualDimension', 'getDimensionByName']),
    ...mapGetters('experience', ['getExperience']),
    wrapperStyles() {
      return `${
        this.isAnyOpen &&
        this.getShowingDropdown &&
        'border-bottom: none; border-radius: 25px 25px 0 0;'
      }`;
    }
  },
  methods: {
    clear() {
      this.$store.commit('searchBar/SET_ACTUAL_SEARCH', '');
    },
    search() {
      this.$store.commit('search/SET_WILDCARD', false);
      const keyword = this.hasSuggestionSelected
        ? this.elementSelected.data.value
        : this.actualSearch;
      const path = this.$urlBuilder('search', {
        path: this.getActualDimension.path,
        keyword
      });

      this.$store.commit('searchBar/SET_ACTUAL_SEARCH', keyword);
      this.$router.push({ path });
    }
  }
};
</script>

<style scoped>
.search-bar {
  position: relative;
  display: inline-flex;
  flex-grow: 1;
  transition: width 0.5s;
  align-items: center;
  border-radius: 25px;
  background-color: #ffffff;
  border: 1px solid rgb(209 200 209);
  width: 100%;
  height: 50px;
  z-index: 200;
}
.search-icon-container {
  width: 50px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #636363;
  margin-right: 5px;
}
</style>
